import { cn } from "core/lib/utils"
import React from "react"

const DownArrow1 = ({ className }: any) => {
  return (
    <svg className={cn(className)} viewBox="0 0 125 295" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0L63 38.9668L63 295L0 224L0 0Z" fill="#1D2A3A" />
      <path d="M125 0L63 39L63 295L125 224L125 0Z" fill="#415166" />
      <g filter="url(#filter0_d_1485_17597)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26 89L62.792 127.893L99 89V112.714L62.792 155L26 112.714L26 89ZM62.792 164.893L26 126L26 149.714L62.792 192L99 149.714L99 126L62.792 164.893ZM62.792 201.893L26 163L26 186.714L62.792 229L99 186.714V163L62.792 201.893Z"
          fill="white"
          fill-opacity="0.1"
          shape-rendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_1485_17597)">
        <mask
          id="path-4-outside-1_1485_17597"
          maskUnits="userSpaceOnUse"
          x="53"
          y="49"
          width="15"
          height="41"
          fill="black"
        >
          <rect fill="white" x="53" y="49" width="15" height="41" />
          <path d="M59.9164 89V57.8C59.6284 57.96 59.2284 58.136 58.7164 58.328C58.2364 58.488 57.7084 58.68 57.1324 58.904C56.5564 59.096 56.0124 59.288 55.5004 59.48C54.9884 59.64 54.5884 59.784 54.3004 59.912V54.44C54.6844 54.248 55.1964 53.992 55.8364 53.672C56.5084 53.352 57.2124 53 57.9484 52.616C58.6844 52.232 59.3724 51.816 60.0124 51.368C60.6844 50.92 61.1964 50.504 61.5484 50.12H67.3084V89H59.9164Z" />
        </mask>
        <path
          d="M59.9164 89V57.8C59.6284 57.96 59.2284 58.136 58.7164 58.328C58.2364 58.488 57.7084 58.68 57.1324 58.904C56.5564 59.096 56.0124 59.288 55.5004 59.48C54.9884 59.64 54.5884 59.784 54.3004 59.912V54.44C54.6844 54.248 55.1964 53.992 55.8364 53.672C56.5084 53.352 57.2124 53 57.9484 52.616C58.6844 52.232 59.3724 51.816 60.0124 51.368C60.6844 50.92 61.1964 50.504 61.5484 50.12H67.3084V89H59.9164Z"
          fill="url(#paint0_linear_1485_17597)"
        />
        <path
          d="M59.9164 89H59.4164V89.5H59.9164V89ZM59.9164 57.8L60.4164 57.8V56.9502L59.6736 57.3629L59.9164 57.8ZM58.7164 58.328L58.8746 58.8023L58.8833 58.7994L58.892 58.7962L58.7164 58.328ZM57.1324 58.904L57.2906 59.3783L57.3022 59.3745L57.3137 59.37L57.1324 58.904ZM55.5004 59.48L55.6496 59.9572L55.6629 59.9531L55.676 59.9482L55.5004 59.48ZM54.3004 59.912H53.8004V60.6814L54.5035 60.3689L54.3004 59.912ZM54.3004 54.44L54.0768 53.9928L53.8004 54.131V54.44H54.3004ZM55.8364 53.672L55.6214 53.2205L55.6128 53.2248L55.8364 53.672ZM57.9484 52.616L58.1797 53.0593H58.1797L57.9484 52.616ZM60.0124 51.368L59.735 50.9519L59.7257 50.9584L60.0124 51.368ZM61.5484 50.12V49.62H61.3285L61.1799 49.7821L61.5484 50.12ZM67.3084 50.12H67.8084V49.62H67.3084V50.12ZM67.3084 89V89.5H67.8084V89H67.3084ZM60.4164 89V57.8L59.4164 57.8V89H60.4164ZM59.6736 57.3629C59.4167 57.5057 59.0427 57.6717 58.5409 57.8598L58.892 58.7962C59.4142 58.6003 59.8402 58.4143 60.1593 58.2371L59.6736 57.3629ZM58.5583 57.8537C58.0691 58.0167 57.5332 58.2117 56.9512 58.438L57.3137 59.37C57.8836 59.1483 58.4038 58.9593 58.8746 58.8023L58.5583 57.8537ZM56.9743 58.4297C56.3931 58.6234 55.8432 58.8174 55.3249 59.0118L55.676 59.9482C56.1816 59.7586 56.7198 59.5686 57.2906 59.3783L56.9743 58.4297ZM55.3513 59.0028C54.8317 59.1651 54.4109 59.3157 54.0974 59.4551L54.5035 60.3689C54.766 60.2523 55.1451 60.1149 55.6496 59.9572L55.3513 59.0028ZM54.8004 59.912V54.44H53.8004V59.912H54.8004ZM54.524 54.8872C54.908 54.6952 55.42 54.4392 56.06 54.1192L55.6128 53.2248C54.9728 53.5448 54.4608 53.8008 54.0768 53.9928L54.524 54.8872ZM56.0514 54.1234C56.7295 53.8005 57.4389 53.4458 58.1797 53.0593L57.7172 52.1727C56.9859 52.5542 56.2874 52.9035 55.6215 53.2206L56.0514 54.1234ZM58.1797 53.0593C58.9337 52.6659 59.6404 52.2388 60.2992 51.7776L59.7257 50.9584C59.1045 51.3932 58.4352 51.7981 57.7172 52.1727L58.1797 53.0593ZM60.2898 51.784C60.9791 51.3245 61.5273 50.883 61.917 50.4579L61.1799 49.7821C60.8656 50.125 60.3898 50.5155 59.7351 50.952L60.2898 51.784ZM61.5484 50.62H67.3084V49.62H61.5484V50.62ZM66.8084 50.12V89H67.8084V50.12H66.8084ZM67.3084 88.5H59.9164V89.5H67.3084V88.5Z"
          fill="white"
          mask="url(#path-4-outside-1_1485_17597)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1485_17597"
          x="22"
          y="87"
          width="79"
          height="146"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.134375 0 0 0 0 0.162 0 0 0 0 0.1875 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1485_17597" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1485_17597" result="shape" />
        </filter>
        <filter
          id="filter1_d_1485_17597"
          x="38.2003"
          y="34.0191"
          width="49.2083"
          height="75.0809"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="9.05" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.48 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1485_17597" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1485_17597" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_1485_17597"
          x1="64.5"
          y1="43.5"
          x2="62.5"
          y2="103"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D5F1FF" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default DownArrow1
